"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTitleRenderer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _context = require("../context");

var _text = require("../text");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ClickableText = (0, _context.styledWithTheme)(_text.Text)(function (_ref) {
  var theme = _ref.theme;
  return {
    cursor: 'pointer',
    color: theme.selectors.color('primary70'),
    ':hover': {
      color: theme.selectors.color('primary80')
    }
  };
});
ClickableText.defaultProps = _objectSpread({}, _text.Text.defaultProps);

var defaultTitleRenderer = function defaultTitleRenderer(_ref2) {
  var titleText = _ref2.titleText,
      toggle = _ref2.toggle;
  return (0, _core.jsx)(ClickableText, {
    "aria-hidden": true,
    onClick: toggle,
    fontSize: "T400"
  }, titleText);
};

exports.defaultTitleRenderer = defaultTitleRenderer;